module.exports = __webpack_public_path__ + "img/406.2e3443b2.jpg";